import styled from "styled-components";
import { Modal } from "../common/Modal/BootstrapModal";
import { tokens } from "../../public/tokens";
import { selectStyles as sharedSelectStyles } from "../common/forms/selectStyles";

const { colors, typography, effects, globals } = tokens;
const { neutral, states, text: textColors, ui, surfaces } = colors;
//TODO: This should be replaced with the proper styled component when available

export const cardPadding = "var(--spacing-6)";

const assignToolbarHeight = "var(--spacing-16)";

export const tableHeaderStyle = { fontSize: typography.fontSize["lg-14px"] };

export const cardStyle = {
    borderRadius: globals["border-radius"],
    border: `1px solid ${ui.border}`,
    boxShadow: effects.effects.shadow.default,
    backgroundColor: neutral.white,
    padding: cardPadding,
};

export const subHeaderStyle = {
    fontSize: typography.fontSize["xl-18px"],
    fontWeight: typography.fontWeights.semibold,
    color: textColors.primary,
    fontFamily: globals["font-family"],
    marginBottom: "var(--spacing-4)",
};

export const FieldGrid = styled.div({
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: "var(--spacing-5)",
    marginBottom: "var(--spacing-5)",

    "& > *": {
        minWidth: 0,
    },

    "& > .career-field--full": {
        gridColumn: "1 / -1",
    },

    "@media (max-width: 1199px)": {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },

    "@media (max-width: 767px)": {
        gridTemplateColumns: "minmax(0, 1fr)",
    },
});

export const tableCustomStyles = {
    headRow: {
        style: {
            backgroundColor: neutral.white,
            borderBottom: `1px solid ${ui.border}`,
            minHeight: "34px",
            height: "34px",
        },
    },
    headCells: {
        style: {
            paddingLeft: "var(--spacing-4)",
            paddingRight: "var(--spacing-4)",
        },
    },
    rows: {
        style: {
            minHeight: "var(--spacing-14)",
            fontFamily: globals["font-family"],
            backgroundColor: neutral.white,
            "&:nth-child(even)": {
                backgroundColor: surfaces["page-background"],
            },
        },
    },
    cells: {
        style: {
            paddingLeft: "var(--spacing-4)",
            paddingRight: "var(--spacing-4)",
            fontSize: typography.fontSize["lg-14px"],
            fontFamily: globals["font-family"],
            color: textColors.primary,
        },
    },
    pagination: {
        style: {
            borderTop: "none",
            minHeight: "68px",
            padding: "var(--spacing-4)",
            fontFamily: globals["font-family"],
        },
    },
};

export const ActionButtonRow = styled.div({
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "var(--spacing-2-5)",
    height: "100%",
});

export const HintText = styled.p({
    margin: 0,
    color: textColors.secondary,
    fontSize: typography.fontSize["lg-14px"],
});

export const tagSelectStyles = {
    ...sharedSelectStyles,
    valueContainer: (base) => ({
        ...base,
        gap: "var(--spacing-1)",
        padding: "var(--spacing-1) var(--spacing-2)",
    }),
    multiValue: (base) => ({
        ...base,
        margin: 0,
        backgroundColor: neutral.grey["200"],
        borderRadius: "2px",
    }),
    multiValueLabel: (base) => ({
        ...base,
        padding: "3px 5px",
        paddingLeft: "5px",
        fontSize: typography.fontSize["md-12px"],
        color: textColors.primary,
    }),
    multiValueRemove: (base) => ({
        ...base,
        paddingLeft: "var(--spacing-1-5)",
        paddingRight: "var(--spacing-1-5)",
        marginLeft: "var(--spacing-1)",
        borderLeft: `1px solid ${ui.border}`,
        borderRadius: 0,
        color: textColors.secondary,
        ":hover": {
            backgroundColor: "transparent",
            color: states.alert.default,
        },
    }),
};

export const careerSelectStyles = {
    ...sharedSelectStyles,
    control: (base, state) => ({
        ...sharedSelectStyles.control(base, state),
        borderColor: state.isFocused
            ? "var(--ring)"
            : "var(--surfaces-border-divider)",
        boxShadow: "none",
        "&:hover": {
            borderColor: state.isFocused
                ? "var(--ring)"
                : "var(--neutral-grey-500)",
        },
    }),
};

export const assignTableCustomStyles = tableCustomStyles;

export const AssignModal = styled(Modal)({
    zIndex: 1060,
    ".modal-dialog": {
        maxWidth: "1176px",
        width: "calc(100% - var(--spacing-8))",
    },
    ".modal-content": {
        border: "none",
        borderRadius: globals["border-radius"],
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        minHeight: "320px",
        maxHeight: "80vh",
    },
});

export const AssignModalHeader = styled.div({
    "&&": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flex: "0 0 auto",
        height: "50px",
        minHeight: "50px",
        maxHeight: "50px",
        padding: "0 var(--spacing-5)",
        backgroundColor: "var(--topbar-color)",
        borderBottom: "none",
        borderRadius: `${globals["border-radius"]} ${globals["border-radius"]} 0 0`,
        color: neutral.white,
    },
    ".modal-title": {
        display: "flex",
        alignItems: "center",
        gap: "var(--spacing-2)",
        margin: 0,
        fontFamily: globals["font-family"],
        fontSize: `${typography.fontSize["base-16px"]} !important`,
        fontWeight: typography.fontWeights.semibold,
        color: neutral.white,
    },
    ".close": {
        margin: 0,
        padding: 0,
        fontSize: typography.fontSize["base-16px"],
        color: neutral.white,
        opacity: 1,
        textShadow: "none",
        cursor: "pointer",
    },
});

export const AssignModalBody = styled.div({
    padding: 0,
    backgroundColor: neutral.white,
    flex: 1,
    minHeight: 0,
    overflow: "auto",

    ".custom-table-div": {
        overflow: "visible",
    },

    ".search-filter-div": {
        minHeight: assignToolbarHeight,
        marginBottom: 0,
        padding: "var(--spacing-3) var(--spacing-4)",
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: neutral.white,
    },

    ".dropdown-menu": {
        maxHeight: "50vh",
        overflowY: "auto",
        zIndex: 3,
    },

    ".reset-btn-group .button-reset .btn-primary": {
        backgroundColor: neutral.black,
        borderColor: neutral.black,
        borderRadius: globals["border-radius"],
        boxShadow: "none !important",
    },
});
